module.exports = __webpack_public_path__ + "img/shutterstock_101584243.0d24b332.jpg";